import React, { Component } from 'react';
import withForm from 'hoc/withForm';
import { Controller } from 'react-hook-form';
import { compose } from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/core components
import Switch from "@material-ui/core/Switch";
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from "@material-ui/core/FormControlLabel";

//core components
import ReadOnlyField from 'components/ReadOnlyField/ReadOnlyField';
import Table from "components/Table/Table.js";
import Button from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import styles from 'assets/jss/material-dashboard-pro-react/views/organizationEditFormStyle';

class OrganizationEditForm extends Component {
	render() {
		const {
			id,
			organization,
			classes,
			onSubmit,
			formMethods,
			toggleFeature,
		} = this.props;

		const { control, trigger, handleSubmit, formState, setValue  } = formMethods;

		const { errors, isDirty, isSubmitting } = formState;

		const switchClasses = {
			switchBase: classes.switchBase,
			checked: classes.switchChecked,
			thumb: classes.switchIcon,
			track: classes.switchBar,
			disabled: classes.disabled,
		};

		const validation = {
			name: {
				maxLength: 255,
			},
			url: {
				maxLength: 255,
			},
		};

		return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className={classes.form}
		>
			<GridContainer>
				<GridItem md={12}>
					<h4 className={classes.subTitle}>General</h4>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					{ id &&
							<ReadOnlyField
								label='ID'
								value={ id || '' }
							/>
					}
				</GridItem>
				<GridItem xs={12} sm={12} md={6}>
					<Controller
						name="name"
						control={control}
						defaultValue={''}
						rules={{
							required: 'Field should not be empty',
							maxLength: {
								value: validation.name.maxLength,
								message: `Maximum ${validation.name.maxLength} characters`
							}
						}}
						render={(props) => (
							<CustomInput
								labelText="Organization Name *"
								error={!!errors.name}
								helperText={errors.name ? errors.name.message : ""}
								formControlProps={{
									fullWidth: true
								}}
								inputProps={{
									value: props.value,
									type: "text"
								}}
								onChange={(event) => {
									const value = event.target.value?.trimStart();
									props.onChange(value);
									trigger('name');
								}}
							/>
						)}
					/>
				</GridItem>
				<GridItem xs={12} sm={12} md={6}>
					<Controller
						name="url"
						control={control}
						defaultValue={''}
						rules={{
							required: 'Field should not be empty',
							maxLength: {
								value: validation.url.maxLength,
								message: `Maximum ${validation.url.maxLength} characters`
							}
						}}
						render={(props) => (
							<CustomInput
								labelText="Organization Portal URL *"
								error={!!errors.url}
								helperText={errors.url ? errors.url.message : ""}
								formControlProps={{
									fullWidth: true
								}}
								inputProps={{
									value: props.value,
									type: "text"
								}}
								onChange={(event) => {
									const value = event.target.value?.trimStart();
									props.onChange(value);
									trigger('url');
								}}
							/>
						)}
					/>
				</GridItem>
				<GridItem md={12}>
					<h4 className={classes.subTitle}>License Info</h4>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
				<Table
					tableHead={[
						"Feature Name",
						"Enable",
					]}
					tableData={[
						{
							custom: true,
							colspan: "2",
							cellData: (
								<span className={classes.subTitle}>eCallMe! – Good Calls</span>
							)
						},
						[
							<span className={classes.feature}>Default Notifications</span>,
							<Controller
								name="features.goodCalls.defaultNotifications"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.goodCalls?.defaultNotifications}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('goodCalls', 'defaultNotifications', value)
													props.onChange(value);
													trigger('features.goodCalls.defaultNotifications');
												}}
												value={organization?.features?.goodCalls?.defaultNotifications}
												classes={switchClasses}
											/>
										}
										classes={{ label: classes.label	}}
										label={organization?.features?.goodCalls?.defaultNotifications ? 'on' : 'off'}
									/>
								)}
							/>,
						],
						[
							<span className={classes.feature}>Custom Notifications</span>,
							<Controller
								name="features.goodCalls.customNotifications"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.goodCalls?.customNotifications}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('goodCalls', 'customNotifications', value)
													props.onChange(value);
													trigger('features.goodCalls.customNotifications');
												}}
												value={organization?.features?.goodCalls?.customNotifications}
												classes={switchClasses}
											/>
										}
										classes={{
											label: classes.label
										}}
										label={organization?.features?.goodCalls?.customNotifications ? 'on' : 'off'}
									/>
								)}
							/>,
						],
						[
							<span className={classes.feature}>Custom Logos</span>,
							<Controller
								name="features.goodCalls.customLogos"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.goodCalls?.customLogos}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('goodCalls', 'customLogos', value)
													props.onChange(value);
													trigger('features.goodCalls.customLogos');
												}}
												value={organization?.features?.goodCalls?.customLogos}
												classes={switchClasses}
											/>
										}
										classes={{
											label: classes.label
										}}
										label={organization?.features?.goodCalls?.customLogos ? 'on' : 'off'}
									/>
								)}
							/>,
						],
						{
							custom: true,
							colspan: "2",
							cellData: (
								<span className={classes.subTitle}>eCallMe! – Fraud Calls</span>
							)
						},
						[
							<span className={classes.feature}>Custom Logos</span>,
							<Controller
								name="features.fraudCalls.customLogos"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.fraudCalls?.customLogos}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('fraudCalls', 'customLogos', value)
													props.onChange(value);
													trigger('features.fraudCalls.customLogos');
												}}
												value={organization?.features?.fraudCalls?.customLogos}
												classes={switchClasses}
											/>
										}
										classes={{ label: classes.label	}}
										label={organization?.features?.fraudCalls?.customLogos ? 'on' : 'off'}
									/>
								)}
							/>,
						],
						{
							custom: true,
							colspan: "2",
							cellData: (
								<span className={classes.subTitle}>Scheduler</span>
							)
						},
						[
							<span className={classes.feature}>Schedule a call</span>,
							<Controller
								name="features.scheduler.scheduleCall"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.scheduler?.scheduleCall}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('scheduler', 'scheduleCall', value)
													props.onChange(value);
													trigger('features.scheduler.scheduleCall');
												}}
												value={organization?.features?.scheduler?.scheduleCall}
												classes={switchClasses}
											/>
										}
										classes={{ label: classes.label	}}
										label={organization?.features?.scheduler?.scheduleCall ? 'on' : 'off'}
									/>
								)}
							/>
						],
						{
							custom: true,
							colspan: "2",
							cellData: (
								<span className={classes.subTitle}>Analytics</span>
							)
						},
						[
							<span className={classes.feature}>View Only</span>,
							<Controller
								name="features.analytics.view"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.analytics?.view}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('analytics', 'view', value)
													props.onChange(value);
													trigger('features.analytics.view');

													if (!value) {
														toggleFeature('analytics', 'alarms', false);
														setValue('features.analytics.alarms', false);
														trigger('features.analytics.alarms');

														toggleFeature('analytics', 'customizeThresholds', false);
														setValue('features.analytics.customizeThresholds', false);
														trigger('features.analytics.customizeThresholds');
													}
												}}
												value={organization?.features?.analytics?.view}
												classes={switchClasses}
											/>
										}
										classes={{ label: classes.label	}}
										label={organization?.features?.analytics?.view ? 'on' : 'off'}
									/>
								)}
							/>
						],
						[
							<span className={classes.feature}>Alarms (Receive through Email & SMS)</span>,
							<Controller
								name="features.analytics.alarms"
								control={control}
								defaultValue={false}
								render={(props) => (
									<Tooltip
										title={!organization?.features?.analytics?.view
											? '\'View only\' must be enabled to turn on this feature'
											: ''}
										placement='left'
									>
										<FormControlLabel
											control={
												<Switch
													checked={organization?.features?.analytics?.alarms}
													onChange={(event) => {
														const value =  event.target.checked;
														toggleFeature('analytics', 'alarms', value)
														props.onChange(value);
														trigger('features.analytics.alarms');
													}}
													value={organization?.features?.analytics?.alarms}
													disabled={!organization?.features?.analytics?.view}
													classes={switchClasses}
												/>
											}
											classes={{ label: classes.label	}}
											label={organization?.features?.analytics?.alarms ? 'on' : 'off'}
										/>
									</Tooltip>
								)}
							/>
						],
						[
							<span className={classes.feature}>Custom Thresholds</span>,
							<Controller
								name="features.analytics.customizeThresholds"
								control={control}
								defaultValue={false}
								render={(props) => (
									<Tooltip
										title={!organization?.features?.analytics?.view
											? '\'View only\' must be enabled to turn on this feature'
											: ''}
										placement='left'
									>
										<FormControlLabel
											control={
												<Switch
													checked={organization?.features?.analytics?.customizeThresholds}
													onChange={(event) => {
														const value =  event.target.checked;
														toggleFeature('analytics', 'customizeThresholds', value)
														props.onChange(value);
														trigger('features.analytics.customizeThresholds');
													}}
													value={organization?.features?.analytics?.customizeThresholds}
													disabled={!organization?.features?.analytics?.view}
													classes={switchClasses}
												/>
											}
											classes={{ label: classes.label	}}
											label={organization?.features?.analytics?.customizeThresholds ? 'on' : 'off'}
										/>
									</Tooltip>
								)}
							/>
						],
						{
							custom: true,
							colspan: "2",
							cellData: (
								<span className={classes.subTitle}>Rating</span>
							)
						},
						[
							<span className={classes.feature}>Collect Ratings</span>,
							<Controller
							name="features.rating.rateCall"
							control={control}
							defaultValue={false}
							render={(props) => (
								<FormControlLabel
									control={
										<Switch
											checked={organization?.features?.rating?.rateCall}
											onChange={(event) => {
												const value =  event.target.checked;
												toggleFeature('rating', 'rateCall', value)
												props.onChange(value);
												trigger('features.rating.rateCall');
											}}
											value={organization?.features?.rating?.rateCall}
											classes={switchClasses}
										/>
									}
									classes={{ label: classes.label	}}
									label={organization?.features?.rating?.rateCall ? 'on' : 'off'}
								/>
							)}
						/>
						],
						{
							custom: true,
							colspan: "2",
							cellData: (
								<span className={classes.subTitle}>Marketing</span>
							)
						},
						[
							<span className={classes.feature}>Broadcast</span>,
							<Controller
								name="features.marketing.broadcast"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.marketing?.broadcast}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('marketing', 'broadcast', value)
													props.onChange(value);
													trigger('features.marketing.broadcast');
												}}
												value={organization?.features?.marketing?.broadcast}
												classes={switchClasses}
											/>
										}
										classes={{
											label: classes.label
										}}
										label={organization?.features?.marketing?.broadcast ? 'on' : 'off'}
									/>
								)}
							/>
						],
						[
							<span className={classes.feature}>Multicast (group of people)</span>,
							<Controller
								name="features.marketing.multicast"
								control={control}
								defaultValue={false}
								render={(props) => (
									<FormControlLabel
										control={
											<Switch
												checked={organization?.features?.marketing?.multicast}
												onChange={(event) => {
													const value =  event.target.checked;
													toggleFeature('marketing', 'multicast', value)
													props.onChange(value);
													trigger('features.marketing.multicast');
												}}
												value={organization?.features?.marketing?.multicast}
												classes={switchClasses}
											/>
										}
										classes={{
											label: classes.label
										}}
										label={organization?.features?.marketing?.multicast ? 'on' : 'off'}
									/>
								)}
							/>
						],
					]}
					// customHeadCellClasses={[
					// 	classes.center,
					// 	classes.description,
					// 	classes.description,
					// 	classes.right,
					// 	classes.right,
					// 	classes.right
					// ]}
				/>
				</GridItem>

				<GridItem xs={12} sm={12} md={12} className={classes.actionContainer}>
					<Button
						color='success'
						size='sm'
						type='submit'
						disabled={
							!!Object.keys(errors).length
							|| isSubmitting
							|| !isDirty
						}
						className={classes.right}
					>Save</Button>
				</GridItem>
			</GridContainer>
		</form>
		)
	}
}

export default compose(
	withStyles(styles),
	withForm,
)(OrganizationEditForm);
